import type { PreviewAttrs } from "./api";

type PreviewAttrKey = PreviewAttrs extends infer T ? (T extends object ? keyof T : never) : never;

type PatientVariable = {
  feelId: string;
  feelLabel: string;
  pickerLabel: string;
};

export const PATIENT_VARIABLES: Record<PreviewAttrKey, PatientVariable> = {
  joint: { feelId: "patient_joint", feelLabel: "Patient joint", pickerLabel: "Joint" },
  ailment: { feelId: "patient_ailment", feelLabel: "Patient ailment", pickerLabel: "Ailment" },
  market: { feelId: "patient_market", feelLabel: "Patient market", pickerLabel: "Market" },
  locale: { feelId: "patient_locale", feelLabel: "Patient locale", pickerLabel: "Locale" },
  premium: { feelId: "patient_premium", feelLabel: "Patient premium", pickerLabel: "Premium" },
  gender: { feelId: "patient_gender", feelLabel: "Patient gender", pickerLabel: "Gender" },
  medication: { feelId: "patient_medications", feelLabel: "Patient medications", pickerLabel: "Substances" },
  medicationBrand: {
    feelId: "patient_medication_brands",
    feelLabel: "Patient medication brands",
    pickerLabel: "Brands",
  },
  dueMedicationBrand: {
    feelId: "patient_due_medication_brands",
    feelLabel: "Patient medication brands due for tracking",
    pickerLabel: "Due for tracking",
  },
  subscription: {
    feelId: "patient_subscriptions",
    feelLabel: "Patient subscriptions",
    pickerLabel: "Subscriptions",
  },
  canMessageTherapist: {
    feelId: "patient_can_message_therapist",
    feelLabel: "Patient can message therapist",
    pickerLabel: "Can message therapist",
  },
};

export const patientVariableLabels: Record<string, string> = Object.fromEntries(
  Object.values(PATIENT_VARIABLES).map(v => [v.feelId, v.feelLabel])
);
